<template>
<div>
    <b-modal
        id="uploadCSVfile"
        title="Upload Configuration"
        size="xl"
        hide-footer
        no-close-on-backdrop>

        <b-form @submit.prevent="uploadCSV">

            <b-row>

                <!-- CSV File -->
                <b-col md="7">

                    <b-form-group
                        label="Upload CSV File"
                        label-for="csvFile">

                        <b-form-file
                            id="csvFile"
                            v-model="csvFile"
                            browse-text="Browse"
                            placeholder="Upload CSV File"
                            accept=".csv"
                            @input="onFileSelected">
                        </b-form-file>

                     

                    </b-form-group>
                     <a
                        href="/img/plannedVehiclesamplefile.csv"
                        download="plannedVehiclesamplefile.csv"
                        target="_blank"
                        >Download Sample CSV</a>
                </b-col>

                <!-- Buttons -->
                <b-col
                    md="5"
                    class="d-flex align-items-start mt-4">

                    <b-button
                        variant="primary"
                        type="submit"
                        class="mr-2">

                        Submit

                    </b-button>

                    <b-button
                        variant="danger"
                        class="mr-2"
                        @click="clearFile">

                        Clear

                    </b-button>
                </b-col>

            </b-row>

        </b-form>

    </b-modal>

</div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
export default {

    name: "BulkCSVUpload",

    data() {
        return {
            csvFile: null,
            publicPath: process.env.BASE_URL
        }
    },

    methods: {

        openModal() {
            this.$bvModal.show("uploadCSVfile");
        },

        onFileSelected(file) {
            if (!file)
                return;
            const extension =
                file.name.split('.').pop().toLowerCase();

            if (extension !== "csv") {
                alert("Please select only CSV file.");
                this.csvFile = null;
            }

        },



        async uploadCSV() {

            if (!this.csvFile) {
                alert("Please select CSV file.");
                return;
            }
            
            // Check CSV format
            try {
                await this.validateCSVFormat(this.csvFile);
                console.log("CSV format is correct.");
            } catch (error) {
                alert(error);
                // Clear selected file
                this.clearFile();
                return;
            }


            let userData = JSON.parse(localStorage.getItem("userData"));

            // FormData for uploadfiletos3
            const uploadForm = new FormData();
            uploadForm.append("file", this.csvFile);

            this.$http.post(`${CONSTANTS.API_URL}/uploadfiletos3`, uploadForm,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            )
            .then(uploadResult => {
                const s3Location = uploadResult.body.file_location;
                console.log(s3Location, '[[[[[[[[[[[[[[[[[[[[[[s3Location]]]]]]]]]]]]]]]]]]]]]]')
        console.log(uploadResult);
        console.log(uploadResult.body);
                // FormData for uploadPlannedVehicleCSV
                const formData = new FormData();

                formData.append("file", this.csvFile);          // CSV file
                formData.append("user", userData.userfirstname + " " + userData.userlastname);
                formData.append("fileS3_location", s3Location);     // S3 URL

                return this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/uploadPlannedVehicleCSV`, formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                );

            })
            .then(result => {

                if (result.body.returnmsg === "Successful") {

                    alert("CSV Uploaded Successfully");
                    this.$emit("refreshListing");//////////////////////////////kuldeep change
                    this.$bvModal.hide("uploadCSVfile");
                    this.clearFile();
                } else {
                    alert("Upload Failed");
                }

            })
            .catch(err => {
                console.log(err);
                alert("Something went wrong.");
            });
        },

        clearFile() {
            this.csvFile = null;
        },


        //kuldeep
        validateCSVFormat(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (event) => {
                    const csvText = event.target.result;

                    // Get only first 2 rows
                    const rows = csvText.split(/\r?\n/).slice(0, 2).map(row => row.split(",").map(value => value.trim()));

                    // -----------------------------------------
                    // Check Row 1
                    // -----------------------------------------

                    const expectedRow1 = [
                        "Planning Date",
                        "Hub ID",
                        "Regular vehicle count",
                        "Adhoc Vehicle count"
                    ];

                    if (rows.length < 1 || rows[0].length !== 4 || !expectedRow1.every((value, index) => rows[0][index] === value)) {
                        reject("Wrong CSV format. Please upload the correct CSV file.");
                        return;
                    }


                    resolve(true);
                };

                reader.onerror = () => {
                    reject("Unable to read CSV file.");
                };

                reader.readAsText(file);
            });
        },


    }

}

</script>

<style scoped>

.form-group label{

    font-weight:600;

}

a{

    text-decoration:none;

}

a:hover{

    text-decoration:underline;

}

</style>